/*
 * Copyright (c) 2020. American Express Company
 */

import BWDataService from './bw-data.service';

class CreateLinkedTokenResponse {
    linkToken: string;
    expiration: string;
    requestId: string;
}

export class PlaidMetaData {
    link_session_id: string;
    mfa_type: string;
    timestamp: string;
    view_name: string;
    error_code?: string;
    error_message?: string;
    error_type?: string;
    exit_status?: string;
    institution_id?: string;
    institution_name?: string;
}

export default class PlaidService extends BWDataService {
    private static _agreeDateTime: string;

    public static setAgreeDateTime = (agreeDateTime: string): void => {
        this._agreeDateTime = agreeDateTime;
    };

    public static getAgreeDateTime = (): string => this._agreeDateTime;

    public static async createLinkToken(): Promise<string> {
        const response: CreateLinkedTokenResponse = await this.post('/plaid/link/token/create', null);
        return response.linkToken;
    }

    public static async addInstitution(
        publicToken: string,
        institutionId: string,
        agreeDateTime?: string
    ): Promise<void> {
        try {
            await this.postInstitution(publicToken, institutionId, agreeDateTime);
        } catch (err) {
            console.error('Error: unable to make new institution', err);
            throw err;
        }
    }

    private static async postInstitution(
        publicToken: string,
        institutionId: string,
        agreeDateTime?: string
    ): Promise<void> {
        const payload: { publicToken: string; institutionId: string; agreeDateTime?: string } = {
            publicToken,
            institutionId
        };
        if (agreeDateTime) {
            payload.agreeDateTime = agreeDateTime;
        }
        await this.post('/institutions', payload);
    }

    public static async reconnectInstitution(id: number): Promise<string> {
        const response: CreateLinkedTokenResponse = await this.get(`/institutions/create_link_token/${id}`);
        return response.linkToken;
    }

    public static async resetInstitutionLogin(id: number): Promise<void> {
        return await this.put(`/institutions/reset_login_required/${id}`, {});
    }

    public static async postUserLog(event: string, meta: PlaidMetaData): Promise<void> {
        await this.post('/plaid/log', {
            event,
            error_code: meta?.error_code || '',
            error_message: meta?.error_message || '',
            error_type: meta?.error_type || '',
            exit_status: meta?.exit_status || '',
            institution_id: meta?.institution_id || '',
            institution_name: meta?.institution_name || ''
        });
    }
}
